import React from "react";
import { FormControl, MenuItem, Typography, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useVideoState } from "../../../../state";
import useDevices from "../../../../hooks/useDevices/useDevices";
import { typography } from "../../../../utils/typography";
import { semanticColors } from "../../../../utils/colors";

export default function AudioOutputList() {
  const { t } = useTranslation();
  const { audioOutputDevices } = useDevices();
  const { activeSinkId, setActiveSinkId } = useVideoState();
  const activeOutputLabel = audioOutputDevices.find(
    device => device.deviceId === activeSinkId
  )?.label;

  return (
    <div className="inputSelect">
      {audioOutputDevices.length > 1 ? (
        <FormControl fullWidth>
          <Typography
            sx={{
              ...typography.body.m,
              color: semanticColors.text.secondary,
              mb: "0.5em"
            }}
          >
            {t("settings.audioOutput")}
          </Typography>
          <Select
            onChange={e => setActiveSinkId(e.target.value as string)}
            value={activeSinkId}
            variant="outlined"
          >
            {audioOutputDevices.map(device => (
              <MenuItem value={device.deviceId} key={device.deviceId}>
                {device.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <>
          <Typography
            sx={{
              ...typography.body.m,
              color: semanticColors.text.secondary,
              mb: "0.25em"
            }}
          >
            {t("settings.audioOutput")}
          </Typography>
          <Typography
            sx={{ ...typography.body.l, color: semanticColors.text.primary }}
          >
            {activeOutputLabel || t("settings.systemDefaultAudio")}
          </Typography>
        </>
      )}
    </div>
  );
}
